// Combine error messages
export function combineErrorMessages(obj: Record<string, string[]>): string[] {
  const resultsArray: string[] = [];
  Object.keys(obj).forEach(function (key) {
    resultsArray.push(obj[key][0]);
  });
  return resultsArray;
}
// EOF

// Get cookie
export const getCookie = (cookieName: string): string | undefined => {
  const cookie: Record<string, string> = {};
  document.cookie.split(";").forEach(function (el) {
    const [key, value] = el.split("=");
    cookie[key.trim()] = value;
  });
  return cookie[cookieName];
};
//  EOF

// Copy text
export const copy = (str: string): boolean => {
  const textField = document.createElement("textarea");
  textField.innerText = str;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand("copy");
  textField.remove();
  return true;
};
// EOF

export const emoji: Record<string, Record<string, string>> = {
  transactions: {
    topup: "💰",
    waiting: "⌛",
  },
  operations: {
    Replenishment: "💰",
    Waiting: "⌛",
    Bonus: "🔥",
    "Ref.comission": "💼",
  },
};

export const formateDate = (rawDate: string | number | Date): string => {
  const date = new Date(rawDate);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const formattedDate = date.toLocaleDateString("en-US", options);

  return formattedDate;
};
